import React, { useState } from "react";
import FormWrapper from "../../components/Timesheet/FormWrapper";
import WorkingHours, { WEEKLY } from "../../components/Timesheet/WorkingHours";
import { alertNotification } from "./../../components/TopNotification/alertNotification";
import { useDispatch, useSelector } from "react-redux";
import { configTimeSheetInit } from "./../../redux/actions";
import history from "../../routes/history";

const TimeSheetWorkingHours = () => {
  const { Period = "daily", Hours = 8 } = useSelector(
    (state) => state.configTimeSheetReducer
  );
  const dispatch = useDispatch();

  const [hourType, setHourType] = useState(Period);
  const [workingHours, setWorkingHours] = useState(Hours);
  const [errorMessage, setErrorMessage] = useState("");

  const handleHourTypeChange = (e) => {
    const newType = e?.target?.value;
    setHourType(newType);
    const defaultValue = newType === WEEKLY ? 40 : 8;
    setWorkingHours(defaultValue);
    setErrorMessage("");
  };

  const handleWorkingHoursChange = (e) => {
    const inputValue = e?.target?.value;

    if (inputValue === "") {
      setWorkingHours("");
      setErrorMessage("Please enter a valid non-negative number");
      return;
    }

    const numericValue = Number(inputValue);
    if (Number.isNaN(numericValue) || numericValue < 0) {
      setErrorMessage("Please enter a valid non-negative number");
      setWorkingHours(inputValue);
      return;
    }

    const maxValue = hourType === WEEKLY ? 168 : 24;
    if (numericValue > maxValue) {
      setErrorMessage(
        hourType === WEEKLY
          ? "Please enter a valid number of hours between 1 and 168."
          : "Please enter a valid number of hours between 1 and 24."
      );
    } else if (numericValue < 1) {
      setErrorMessage("Working hours can't be less than 1.");
    } else {
      setErrorMessage("");
    }

    setWorkingHours(numericValue);
  };

  const handleNext = () => {
    const numericHours = Number(workingHours);
    if (
      errorMessage ||
      Number.isNaN(numericHours) ||
      numericHours <= 0
    ) {
      return;
    }

    dispatch(configTimeSheetInit({ Period: hourType, Hours: workingHours }));
    history.push("/start-shift");
  };
  return (
    <FormWrapper
      pageTitle={"Configure Timesheet"}
      percent={60}
      nextFunction={handleNext}
      backFunction={() => history.goBack()}
    >
      <WorkingHours
        {...{
          hourType,
          workingHours,
          handleHourTypeChange,
          handleWorkingHoursChange,
          errorMessage,
        }}
      />
    </FormWrapper>
  );
};

export default TimeSheetWorkingHours;
